export const coachWorld = {
  navbar: {
    solutions: "Why CoachWorld?",
    features: "Features",
    plusServices: "Plus Services",
    howItWorks: "How It Works",
    pricing: "Pricing",
    faq: "FAQ",
    about: "About Us",
    waitlistButton: "Request Free Callback",
    subpages: {
      website: "Website Builder",
      booking: "Booking System",
      marketing: "AI Marketing",
    },
  },
  seo: {
    title: "CoachWorld powered by Bespire - Platform for Coaches",
    description: "Build your coaching business in one place: website, booking, marketing, marketplace presence and professional community.",
    keywords: "coach platform, coaching website, coach marketplace, coaching booking, coach community",
  },
  hero: {
    badge: "CoachWorld powered by Bespire",
    title: "Your coaching business deserves the best tools",
    subtitle: "Professional website, smart booking system, AI marketing and digital product sales — on a single platform, tailored for coaches.",
    description: "Join the CoachWorld community and get marketplace presence, professional events and dedicated growth support.",
    cta: "Request Free Callback",
    elviraBadge: "\"Finally a platform built by coaches, for coaches.\" — Elvira Dobos",
    trustBadges: [
      "Recommended by Hungarian Coach Association",
      "500+ coaches using it",
      "85% time saved",
    ],
    chatSimulation: {
      userMessage: "I want a coaching website with a booking system and online course sales",
      aiResponse: "I'll help right away! I'm creating a professional coaching website with individual and group session booking, online course sales, and automatic invoicing. What coaching area do you work in?",
    },
  },
  ambassador: {
    badge: "The Face of CoachWorld",
    name: "Elvira Dobos",
    title: "Certified Business Coach, Master Level",
    roles: [
      "President of the Association of Hungarian Coach Organizations",
      "Founder & Editor-in-Chief of Magyar Coachszemle",
      "Co-founder of MyPro Solutions",
      "Certified Mental Health Professional",
    ],
    quote: "CoachWorld powered by Bespire gives coaches the tools to finally focus on their professional work, while administration and client acquisition run automatically.",
    whySupports: "Why does she stand behind it?",
    whyDescription: "Elvira believes that professionalizing the coaching industry requires modern, digital tools. CoachWorld delivers exactly that: an all-in-one platform where coaches can focus on their clients.",
  },
  about: {
    seo: {
      title: "About Us — CoachWorld powered by Bespire",
      description: "Meet the team behind CoachWorld, our mission and vision. A platform supported by Elvira Dobos, President of the Hungarian Coach Association.",
    },
    heroTitle: "The CoachWorld Mission",
    heroSubtitle: "A platform built by coaches, for coaches — so the coaching profession finally gets the modern digital tools it deserves.",
    mission: {
      title: "Our Mission",
      description: "CoachWorld was created to help professionalize the coaching industry. We believe every coach deserves a professional online presence, intelligent business tools, and a supportive professional community — without having to become an IT expert.",
      points: [
        "Professional tools for every coach",
        "A community that supports and develops",
        "AI technology that saves time",
        "A marketplace connecting coaches and clients",
      ],
    },
    vision: {
      title: "Our Vision",
      description: "We're building an ecosystem where the coaching profession thrives. Where coaches focus on clients, administration is automatic, and professional development is continuous. CoachWorld isn't just software — it's a movement to modernize the coaching profession.",
    },
    ambassador: {
      badge: "The Face of CoachWorld",
      title: "Elvira Dobos",
      subtitle: "Certified Business Coach, Master Level",
      bio: "Elvira Dobos is the President of the Association of Hungarian Coach Organizations, founder and editor-in-chief of Magyar Coachszemle, co-founder of MyPro Solutions, and a certified mental health professional. With over 15 years of experience, she is one of the most influential figures in the Hungarian coaching profession.",
      roles: [
        "President of the Association of Hungarian Coach Organizations",
        "Founder & Editor-in-Chief of Magyar Coachszemle",
        "Co-founder of MyPro Solutions",
        "Certified Mental Health Professional",
      ],
      quote: "CoachWorld powered by Bespire gives coaches the tools to finally focus on their professional work, while administration and client acquisition run automatically.",
      whyTitle: "Why does she stand behind it?",
      whyDescription: "Elvira believes that professionalizing the coaching industry requires modern, digital tools. CoachWorld delivers exactly that: an all-in-one platform where coaches can focus on their clients. Her decades of experience and commitment to the profession guarantee that the platform truly serves coaches' needs.",
    },
    bespire: {
      title: "The Bespire Technology",
      description: "CoachWorld is the coach-specific version of the Bespire platform. Bespire is a Hungarian-developed, AI-powered business platform offering website building, booking systems, digital product sales, and marketing automation. CoachWorld complements this robust technology base with coach-specific features: marketplace, professional community, events, and personalized growth support.",
    },
    cta: {
      title: "Join the CoachWorld Community",
      subtitle: "Request a free callback and learn how we can help develop your coaching business.",
      button: "Request Free Callback",
    },
  },
  marketplace: {
    badge: "CoachHub Marketplace",
    title: "Where clients find you",
    subtitle: "The CoachHub Marketplace is a dedicated marketplace where potential clients can search, filter, and choose from CoachWorld coaches.",
    howItWorks: {
      title: "How does it work?",
      steps: [
        {
          title: "Your profile is created automatically",
          description: "When you activate your CoachWorld membership, your marketplace profile is automatically created based on your website and services.",
        },
        {
          title: "Clients find you",
          description: "Potential clients can filter and search for coaches by specialty, location, price, rating, and availability.",
        },
        {
          title: "Direct booking",
          description: "Clients can book directly from the marketplace — you don't need to do anything, inquiries come on their own.",
        },
      ],
    },
    benefits: [
      "8-12 new inquiries per month on average",
      "SEO-optimized coach profile",
      "Display ratings and references",
      "Featured position in Pro plan",
    ],
    mockup: {
      searchPlaceholder: "Search: business coach London...",
      filterSpecialty: "Specialty",
      filterLocation: "Location",
      filterPrice: "Price range",
      resultsTitle: "Results",
      profileBadge: "CoachWorld member",
      bookButton: "Book",
      ratingLabel: "rating",
    },
  },
  impact: {
    title: "Numbers That Speak",
    subtitle: "Coaches using CoachWorld achieve these results on average",
    stats: [
      { value: "500+", label: "Coaches on the platform" },
      { value: "10,000+", label: "Sessions booked monthly" },
      { value: "85%", label: "Time saved on administration" },
      { value: "3x", label: "More online inquiries on average" },
      { value: "40%", label: "Revenue growth in first 6 months" },
      { value: "24/7", label: "AI assistant always available" },
    ],
  },
  solutions: {
    title: "Every tool your coaching business needs",
    subtitle: "The full Bespire software tailored for coaches — explained in detail",
    items: [
      {
        title: "Professional coaching website",
        description: "The AI assistant helps you build your entire coaching website: introduction, methodology, references, services. No programmer needed, no designer needed — you chat with the AI, and your site is ready.",
        features: [
          "Coaching methodology and philosophy page",
          "References and client testimonials",
          "Service portfolio with detailed descriptions",
          "SEO optimized content automatically",
          "Custom domain and brand identity",
          "Mobile-optimized display",
        ],
        detailsButton: "Website Builder details",
        chat: {
          title: "Bespire AI Assistant",
          online: "Online",
          messages: [
            { role: "user" as const, content: "I want a coaching website where I can present my methodology and give clients booking options." },
            { role: "assistant" as const, content: "Great! I'll create a professional coaching website. What coaching area do you work in?", list: ["Introduction page with methodology", "Services detailed", "Booking system integrated", "Client testimonials section"] },
            { role: "user" as const, content: "Business coaching, mainly for executives and teams." },
            { role: "assistant" as const, content: "Perfect! I've created your executive coaching website with a modern, professional design. Check the preview!" },
          ],
        },
      },
      {
        title: "Smart booking system",
        description: "Individual and group sessions, automatic reminders, calendar sync, passes, payment management — everything a coaching practice needs.",
        features: [
          "Online booking for individual coaching sessions",
          "Group workshops and programs",
          "Automatic email and SMS reminders",
          "Google Calendar and Outlook sync",
          "Pass and package management",
          "Online and in-person session management",
        ],
        detailsButton: "Booking System details",
        chat: {
          title: "Bespire AI Assistant",
          online: "Online",
          messages: [
            { role: "user" as const, content: "I want my clients to be able to book appointments themselves." },
            { role: "assistant" as const, content: "I'll set up your booking system! What types of sessions do you offer?" },
            { role: "user" as const, content: "Individual coaching for 60 minutes and group workshops for 3 hours." },
            { role: "assistant" as const, content: "Done! Your clients can now book:", list: ["60-minute individual session — €75", "3-hour group workshop — €45/person", "Automatic reminder 24 hours before", "Google Calendar synced"] },
          ],
        },
      },
      {
        title: "Digital product sales",
        description: "Sell online courses, e-books, coaching templates, workbooks. Automatic access after payment, integrated invoicing.",
        features: [
          "Online courses and trainings",
          "E-books and coaching workbooks",
          "Downloadable templates and tools",
          "Automatic access after payment",
          "Integrated payment and invoicing",
          "Coupon and promo code management",
        ],
        detailsButton: "Marketing details",
        chat: {
          title: "Bespire AI Assistant",
          online: "Online",
          messages: [
            { role: "user" as const, content: "I have a coaching workbook I'd like to sell online." },
            { role: "assistant" as const, content: "Great! I'll add it to your digital products. What should be the price and description?" },
            { role: "user" as const, content: "\"Leadership Self-Awareness Workbook\" — €15, PDF format." },
            { role: "assistant" as const, content: "Done! The workbook is available on your website:", list: ["Automatic PDF download after payment", "Invoicing automatically", "Product page SEO optimized", "Promo code created: COACH20"] },
          ],
        },
      },
      {
        title: "AI marketing and content creation",
        description: "AI generates your social media posts, blog articles, newsletters. The AI knows your coaching specialty and your tone.",
        features: [
          "Social media post generation on coaching topics",
          "Blog and professional article writing with AI",
          "Email marketing and newsletter",
          "Hashtag and SEO suggestions",
          "Instagram, Facebook, LinkedIn integration",
          "Content calendar and scheduling",
        ],
        detailsButton: "Marketing details",
        chat: {
          title: "Bespire AI Assistant",
          online: "Online",
          messages: [
            { role: "user" as const, content: "Write me a LinkedIn post about preventing executive burnout." },
            { role: "assistant" as const, content: "I've written a professional LinkedIn post matching your profile style:", list: ["🔥 Do you recognize the signs? — 5 early warnings...", "Professional, credible tone", "Relevant hashtags generated", "One-click publish ready"] },
            { role: "user" as const, content: "This is great! Make a newsletter from it too." },
            { role: "assistant" as const, content: "The newsletter is ready and scheduled for tomorrow at 8:00 AM. Going out to 347 subscribers." },
          ],
        },
      },
    ],
  },
  howItWorks: {
    title: "How to Get Started?",
    subtitle: "Two paths ahead — choose what's comfortable for you",
    pathA: {
      tab: "Do it yourself, with AI help",
      steps: [
        { title: "Get in touch", description: "Request a free callback and get access to the system." },
        { title: "Build your site", description: "The AI assistant helps you set up your coaching website, services, and booking system." },
        { title: "Launch and grow", description: "Publish your site, accept bookings, and use AI marketing tools for client acquisition." },
      ],
    },
    pathB: {
      tab: "We'll do it for you",
      title: "No time at all?",
      description: "We'll build your complete coaching system, you just use it. One-time fee: €150 + VAT.",
      steps: [
        { title: "Consultation", description: "We discuss what coaching services you offer and what site you want." },
        { title: "We build your system", description: "We create your website, set up the booking system, upload your services." },
        { title: "Handover and training", description: "We show you how to use the system and AI assistant for daily operations." },
      ],
      cta: "Request Free Callback",
    },
  },
  plusServices: {
    badge: "Exclusive Benefits",
    title: "Exclusive benefits for CoachWorld members",
    subtitle: "These services are exclusively available to CoachWorld members, on top of the full Bespire platform",
    items: [
      {
        title: "CoachHub Marketplace Presence",
        description: "Your profile appears on the CoachHub marketplace, where clients can search, filter, and choose from coaches. They find you by specialty, location, price and ratings.",
        example: "A life coach gets 8-12 new inquiries monthly from the marketplace — clients specifically looking for coaching services.",
        icon: "Store",
      },
      {
        title: "Professional Community",
        description: "A closed coach community where you can exchange experiences, ask questions, and collaborate with other coaches. Weekly peer coaching groups where you can work on your own cases.",
        example: "Weekly peer coaching groups where you can work on your own cases with other coaches.",
        icon: "Users",
      },
      {
        title: "Monthly Professional Events",
        description: "Online workshops, masterclasses, guest speakers — on business, psychology, and marketing topics. All events are available as recordings too.",
        example: "Latest topic: \"How to build a 6-figure coaching business online?\" — with 120+ participants.",
        icon: "Calendar",
      },
      {
        title: "Dedicated Growth Advisor",
        description: "Not a helpdesk, but a personal contact who proactively helps optimize your site and business. Monthly 1-on-1 consultation.",
        example: "Monthly 1-on-1 consultation reviewing your statistics with suggestions for improvement.",
        icon: "Headphones",
      },
      {
        title: "Client Acquisition Strategies & Materials",
        description: "Monthly marketing materials specifically for coaches: how to get more clients online, what content works, how to position yourself. Ready templates and proven funnels.",
        example: "Ready-to-use content templates, email sequence samples, and proven client acquisition funnels.",
        icon: "TrendingUp",
      },
    ],
  },
  comparison: {
    title: "Why CoachWorld instead of regular Bespire?",
    subtitle: "The CoachWorld package includes everything Bespire offers — and much more",
    headers: ["Feature", "Bespire", "CoachWorld"],
    features: [
      { name: "Professional website", bespire: true, coachWorld: true },
      { name: "Booking system", bespire: true, coachWorld: true },
      { name: "Digital product sales", bespire: true, coachWorld: true },
      { name: "AI marketing tools", bespire: true, coachWorld: true },
      { name: "Automatic invoicing", bespire: true, coachWorld: true },
      { name: "Coach marketplace presence", bespire: false, coachWorld: true },
      { name: "Professional coach community", bespire: false, coachWorld: true },
      { name: "Monthly professional events", bespire: false, coachWorld: true },
      { name: "Dedicated growth advisor", bespire: false, coachWorld: true },
      { name: "Client acquisition materials", bespire: false, coachWorld: true },
      { name: "Coach-specific templates", bespire: false, coachWorld: true },
    ],
  },
  successStories: {
    title: "Coaches already using CoachWorld",
    subtitle: "Real results from real coaches",
    stories: [
      {
        name: "Réka Szilágyi",
        type: "Executive Coach",
        quote: "Thanks to CoachWorld, 70% of my bookings come automatically — I can finally focus on the coaching work.",
        stats: [
          { value: "70%", label: "Automatic bookings" },
          { value: "3x", label: "More clients" },
        ],
      },
      {
        name: "Péter Tóth",
        type: "Business Coach",
        quote: "My online course brought 40 sales in the first month. The marketplace presence is worth gold.",
        stats: [
          { value: "40", label: "Course sales/mo" },
          { value: "+€1,100", label: "Extra revenue" },
        ],
      },
      {
        name: "Ildikó Kovács",
        type: "Life Coach",
        quote: "The professional community is the best investment. I learn something every week that I immediately apply in practice.",
        stats: [
          { value: "12", label: "New clients/mo" },
          { value: "4.9★", label: "Average rating" },
        ],
      },
    ],
  },
  featureBento: {
    title: "Everything you get in the CoachWorld package",
    subtitle: "An overview of all features",
    platformLabel: "Platform features",
    extraLabel: "CoachWorld extras",
    features: [
      { title: "AI website builder", description: "You chat with the AI, and it builds your entire coaching website — introduction, services, references", icon: "Globe" },
      { title: "Booking system", description: "Individual and group session booking", icon: "CalendarCheck" },
      { title: "Digital products", description: "Courses, e-books, workbooks", icon: "ShoppingBag" },
      { title: "AI marketing", description: "Posts, blog articles, newsletter generation — in your voice, on your topics, automatically", icon: "Megaphone" },
      { title: "Marketplace", description: "Clients find you on the marketplace", icon: "Store" },
      { title: "Invoicing", description: "Automatic invoice for every transaction", icon: "Receipt" },
      { title: "Client management", description: "CRM, tags, segmentation", icon: "Users" },
      { title: "Calendar sync", description: "Google Calendar, Outlook integration", icon: "Calendar" },
      { title: "Reminders", description: "Automatic email and SMS notifications — your clients never miss a session", icon: "Bell" },
      { title: "Professional community", description: "Closed coach networking platform", icon: "Heart" },
      { title: "Monthly events", description: "Workshops, masterclasses, speakers", icon: "Video" },
      { title: "Analytics", description: "Detailed statistics and reports", icon: "BarChart" },
    ],
  },
  pricing: {
    title: "Choose your CoachWorld plan",
    subtitle: "Exclusive pricing — only available here, a comprehensive coaching package different from the standard Bespire plan",
    plans: {
      alap: {
        badge: "CoachWorld Basic",
        name: "CoachWorld Basic",
        price: "€75",
        currency: "",
        period: "/ month + VAT",
        description: "The full Bespire platform + CoachWorld basic services",
        features: [
          "Professional coaching website",
          "Booking system (individual + group)",
          "Digital product sales",
          "AI marketing tools (10 credits/mo)",
          "Automatic invoicing",
          "Client management and CRM",
          "Marketplace presence",
          "Professional community access",
          "Monthly online events",
        ],
        cta: "Request Free Callback",
      },
      pro: {
        badge: "CoachWorld Pro",
        name: "CoachWorld Pro",
        price: "€135",
        currency: "",
        period: "/ month + VAT",
        popular: "Most Popular",
        description: "Everything in Basic + premium services for maximum growth",
        features: [
          "Everything in Basic",
          "AI assistant for daily work",
          "Featured marketplace position",
          "Dedicated growth advisor",
          "Monthly 1:1 strategy consultation",
          "Premium client acquisition materials",
          "Priority technical support",
          "Advanced analytics and reports",
          "Custom domain setup",
        ],
        cta: "Request Free Callback",
      },
    },
    setup: {
      title: "Full Setup Service",
      price: "€150",
      currency: "",
      suffix: "+ VAT (one-time)",
      description: "Don't want to bother? We'll build your complete system, you just use it.",
      features: [
        "Website built with your content",
        "Services and prices uploaded",
        "Booking system configuration",
        "Email marketing setup",
        "Basic SEO settings",
        "Personal platform training (60 min)",
      ],
    },
    cta: "Request Free Callback",
    guarantee: [
      "No hidden costs",
      "Cancel anytime",
      "Response within 48 hours",
      "Satisfaction guarantee",
    ],
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Everything you need to know about CoachWorld",
    items: [
      { question: "Who is CoachWorld for?", answer: "Every coach who wants to professionally build their online presence: life coaches, business coaches, executive coaches, team coaches, career coaches, and coaching consultants." },
      { question: "What's the difference between CoachWorld Basic and Pro?", answer: "The Basic plan includes the full platform and community features. The Pro plan additionally gives you a dedicated growth advisor, monthly strategy consultation, featured marketplace position, AI assistant for daily work, and premium materials." },
      { question: "Is this the same as a regular Bespire subscription?", answer: "No. CoachWorld is a standalone, exclusive package that includes the full Bespire platform but with coach-specific extras: marketplace, community, events, consulting. This price is only available here." },
      { question: "How does my profile appear on the marketplace?", answer: "After activating your CoachWorld membership, we automatically create your marketplace profile based on your website data. Clients can filter by specialty, location, price, and ratings." },
      { question: "What events are there monthly?", answer: "2-4 online events monthly: professional workshops, masterclasses on business and marketing topics, guest speakers, and networking opportunities. All events are available as recordings too." },
      { question: "What is the one-time setup fee?", answer: "€150 + VAT one-time fee for us to build your complete system: website, booking system, service upload, and personal training." },
      { question: "Can I try before I pay?", answer: "Request a free callback and we'll demonstrate the platform in detail. We'll answer all your questions before you make any decision." },
      { question: "Can I cancel anytime?", answer: "Yes, there's no commitment. You can cancel your monthly membership at any time, and your data will be preserved." },
    ],
  },
  newsletter: {
    title: "Request a Free Callback",
    subtitle: "Leave your phone number and we'll call you back within 48 hours — completely free, no obligation.",
    namePlaceholder: "Your name (e.g. John Smith)",
    phonePlaceholder: "Your phone number (e.g. +1 555 123 4567)",
    professionLabel: "Your profession",
    professionDefault: "Coach",
    setupOption: {
      label: "Would you like us to fully set up your site?",
      yes: "Yes, I want the full setup (€150 + VAT, one-time fee)",
      no: "No, I'd like to manage it myself",
    },
    websiteStatus: {
      label: "Do you already have a website?",
      hasWebsite: "Yes, I have a website",
      noWebsite: "No, I'm just starting",
      websitePlaceholder: "Enter your website URL (e.g. www.example.com)",
    },
    submitButton: "Request Free Callback",
    privacyNote: "We handle your data confidentially. The callback is completely free.",
    callbackNote: "Callback within 48 hours on business days.",
    freeBadge: "100% free",
  },
  footer: {
    tagline: "Your coaching business deserves the best digital tools.",
    platformTitle: "Platform",
    platformLinks: [
      { label: "Professional Website", path: "/coachworld/website" },
      { label: "Booking System", path: "/coachworld/booking" },
      { label: "Marketing Tools", path: "/coachworld/marketing" },
      { label: "About Us", path: "/coachworld/about" },
    ],
    sectionsTitle: "Explore",
    sectionLinks: [
      { label: "Why CoachWorld?", id: "solutions" },
      { label: "How It Works", id: "how-it-works" },
      { label: "Pricing", id: "pricing" },
      { label: "FAQ", id: "faq" },
    ],
    contactTitle: "Contact",
    contactDescription: "Have questions? Request a free callback and we'll help you get started.",
    ctaButton: "Request Callback",
    copyright: "© 2025 CoachWorld powered by Bespire. All rights reserved.",
    bespireNote: "Powered by Bespire technology.",
  },
  websitePage: {
    seo: {
      title: "Coaching Website Builder — CoachWorld powered by Bespire",
      description: "Build a professional coaching website with AI assistance. Introduction, methodology, references, booking — in minutes.",
    },
    hero: {
      title: "A coaching website that wins clients",
      subtitle: "The AI assistant helps build your entire website — no programmer, no designer needed. You chat, and it's done.",
      cta: "Request Free Callback",
    },
    features: {
      title: "Every feature a coaching website needs",
      subtitle: "A detailed look at the most important website builder features",
      highlights: [
        {
          title: "AI content writing that knows your field",
          description: "The AI doesn't write generic text — it learns your coaching methodology, target audience and tone. Every introduction, service description and blog article will be authentic and personal.",
          icon: "Sparkles",
          points: [
            "Introduction in your style, in minutes",
            "Service pages with detailed descriptions",
            "Blog articles that create SEO value",
            "Multilingual content generation",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Drag & drop that's truly simple",
          description: "No coding, no design skills needed. Use the drag-and-drop editor to arrange sections, choose pre-built blocks and customize colors.",
          icon: "Layout",
          points: [
            "Pre-built section blocks",
            "Color and font customization",
            "Image gallery and video embedding",
            "Live preview while editing",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "SEO that works automatically",
          description: "No SEO expertise needed. The system automatically optimizes meta titles, descriptions, image alt texts and page speed.",
          icon: "Search",
          points: [
            "Automatic meta title and description",
            "Image optimization and alt texts",
            "Page speed optimization",
            "Google Search Console integration",
          ],
          mockupLines: ["", "", "", "", ""],
        },
      ],
      items: [
        { title: "AI content writing", description: "AI writes your introduction, service descriptions, blog articles — in your voice.", icon: "Sparkles" },
        { title: "Drag & drop editing", description: "Drag-and-drop editor to arrange anything — no code needed.", icon: "Layout" },
        { title: "Coaching templates", description: "Pre-made, coach-specific page templates.", icon: "FileText" },
        { title: "Custom domain", description: "Use your own domain name for professional appearance.", icon: "Globe" },
        { title: "Mobile optimized", description: "Every page automatically looks perfect on phone and tablet.", icon: "Smartphone" },
        { title: "Built-in SEO", description: "Automatic SEO optimization so you're found on Google.", icon: "Search" },
        { title: "Service portfolio", description: "Detailed service pages with pricing and booking buttons.", icon: "Briefcase" },
        { title: "Client testimonials", description: "Showcase your references and client feedback.", icon: "Star" },
        { title: "Blog and content", description: "Publish professional articles that position you.", icon: "BookOpen" },
      ],
    },
    deepDive: {
      title: "How your coaching website is built",
      sections: [
        {
          title: "1. Chat with the AI about your goals",
          description: "The AI assistant asks about your coaching area, target audiences, and services. Based on this, it creates the complete website structure and content.",
          visual: "chat",
        },
        {
          title: "2. Choose your look",
          description: "Pick from pre-made coaching templates, or customize colors, fonts, and layout. Every template is mobile-optimized and professional.",
          visual: "template",
        },
        {
          title: "3. Publish and launch",
          description: "One-click publish on your own domain. The AI continuously helps with content updates, SEO optimization, and blog articles.",
          visual: "publish",
        },
      ],
    },
    useCases: {
      title: "Coaching website types",
      items: [
        {
          title: "Executive coaching",
          description: "Professional, corporate appearance for executive coaching services. References, methodology, corporate inquiry option.",
        },
        {
          title: "Life coaching",
          description: "Warm, personal tone with individual development programs, online booking, and blog section.",
        },
        {
          title: "Team coaching",
          description: "Team coaching and workshop portfolio, group booking options, corporate presentation materials.",
        },
      ],
    },
    stats: [
      { value: "30 min", label: "Average website build time" },
      { value: "98%", label: "Mobile-optimized pages" },
      { value: "3x", label: "More Google visibility" },
      { value: "€0", label: "Extra development cost" },
    ],
    faq: {
      title: "Website Builder — FAQ",
      items: [
        { question: "Is my site really ready in 30 minutes?", answer: "Yes! The AI assistant helps build your entire website. You just answer content questions, the AI creates the pages." },
        { question: "Can I use my own domain?", answer: "Yes, you can connect any custom domain to your coaching website. We help with the setup." },
        { question: "What if I'm not good at writing?", answer: "The AI assistant generates content for you. Just provide your coaching area and target audience, it writes the rest." },
        { question: "Can I change the design later?", answer: "Yes, you can modify colors, layout, images at any time. Your data is preserved." },
        { question: "How many pages can I create?", answer: "Unlimited pages: introduction, services, blog, references, contact — everything you need." },
        { question: "Is there an e-commerce feature?", answer: "Yes! You can sell digital products (e-books, courses, workbooks) directly from your website, with automatic payment and access." },
      ],
    },
    cta: {
      title: "Ready for your coaching website?",
      subtitle: "Request a free callback and we'll show you how your website is built in 30 minutes.",
      button: "Request Free Callback",
    },
  },
  bookingPage: {
    seo: {
      title: "Coaching Booking System — CoachWorld powered by Bespire",
      description: "Smart booking system for coaches: individual sessions, group workshops, passes, automatic reminders.",
    },
    hero: {
      title: "A booking system that works for you",
      subtitle: "Your clients can book anytime — you just focus on coaching. Individual and group sessions, passes, payments, reminders — all automatic.",
      cta: "Request Free Callback",
    },
    features: {
      title: "Everything a coaching booking system needs",
      subtitle: "A detailed look at the most important booking features",
      highlights: [
        {
          title: "Individual and group sessions",
          description: "Your clients choose the session type, time slot, and pay online. You just focus on coaching. Group workshops with capacity limits and automatic registration.",
          icon: "User",
          points: [
            "Different session types and durations",
            "Online and in-person session management",
            "Group workshops with capacity limits",
            "Automatic confirmation email",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Pass and package management",
          description: "Create 5, 10, 20-session passes that automatically track sessions. Clients simply book a session from their pass, the system deducts one.",
          icon: "CreditCard",
          points: [
            "Custom session count passes",
            "Automatic session tracking",
            "Expiry date and warnings",
            "One-click pass renewal",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Calendar sync and reminders",
          description: "Bookings automatically appear in your Google Calendar or Outlook. Your clients get automatic reminders via email and SMS.",
          icon: "Calendar",
          points: [
            "Google Calendar and Outlook sync",
            "Email reminder 24 hours before",
            "SMS reminder 1 hour before",
            "Double booking protection",
          ],
          mockupLines: ["", "", "", "", ""],
        },
      ],
      items: [
        { title: "Individual sessions", description: "Clients choose the time, session type and pay online.", icon: "User" },
        { title: "Group workshops", description: "Advertise group programs with capacity limits and automatic registration.", icon: "Users" },
        { title: "Pass management", description: "Create 5, 10, 20-session passes.", icon: "CreditCard" },
        { title: "Calendar sync", description: "Google Calendar and Outlook sync.", icon: "Calendar" },
        { title: "Automatic reminders", description: "Email and SMS reminders before the session.", icon: "Bell" },
        { title: "Online and in-person", description: "Zoom/Google Meet link automatically.", icon: "Video" },
        { title: "Payment processing", description: "Online card payment, automatic invoicing.", icon: "Wallet" },
        { title: "Cancellation handling", description: "Configurable cancellation policies.", icon: "RefreshCw" },
        { title: "Waiting lists", description: "If a time slot is full, interested clients can join the waiting list.", icon: "Clock" },
      ],
    },
    deepDive: {
      title: "How the booking system works in practice",
      sections: [
        {
          title: "The client's perspective",
          description: "Your client opens your website, selects a service, picks a time slot, pays online, and gets an automatic confirmation. No calling, no emailing — everything is automatic.",
          visual: "client",
        },
        {
          title: "Your perspective",
          description: "You see incoming bookings in your calendar, the system reminds you of sessions, manages passes and payments. If a client cancels, the waitlist person gets notified automatically.",
          visual: "coach",
        },
        {
          title: "Automated communication",
          description: "The system sends confirmation, reminders 24h and 1h before, and a follow-up email afterward. All automatically, in your name.",
          visual: "automation",
        },
      ],
    },
    useCases: {
      title: "Booking scenarios",
      items: [
        {
          title: "Individual coaching program",
          description: "10-session pass for individual coaching sessions, weekly, with automatic reminders and progress tracking.",
        },
        {
          title: "Group workshop series",
          description: "4-part workshop series with 12-person capacity limit, automatic registration and waiting list.",
        },
        {
          title: "Intro session",
          description: "Free 30-minute introductory call, after which the client can immediately book a paid session.",
        },
      ],
    },
    stats: [
      { value: "85%", label: "Administration savings" },
      { value: "0", label: "Double bookings" },
      { value: "95%", label: "Show-up rate with reminders" },
      { value: "24/7", label: "Booking always available" },
    ],
    faq: {
      title: "Booking System — FAQ",
      items: [
        { question: "Can my clients pay online?", answer: "Yes! Card payment is integrated. The client pays when booking, and you get an automatic invoice." },
        { question: "What if a client cancels?", answer: "You can set cancellation policies (e.g. free 24 hours before). The system automatically handles refunds." },
        { question: "Does it sync with my calendar?", answer: "Yes, with Google Calendar and Outlook sync. Bookings automatically appear in your calendar." },
        { question: "Can I create group bookings?", answer: "Yes! You can create group workshops with capacity limits, automatic registration and waiting lists." },
        { question: "How do passes work?", answer: "You create a pass type (e.g. 10 sessions), the client purchases it, and then books sessions from their pass. The system automatically tracks used sessions." },
        { question: "Can I manage both online and in-person sessions?", answer: "Yes! The system handles both types. For online sessions, it automatically generates Zoom/Google Meet links." },
      ],
    },
    cta: {
      title: "Automate your bookings",
      subtitle: "Request a free callback and we'll show you how to save 5+ hours per week on administration.",
      button: "Request Free Callback",
    },
  },
  marketingPage: {
    seo: {
      title: "AI Marketing for Coaches — CoachWorld powered by Bespire",
      description: "AI marketing tools for coaches: social media posts, blog articles, newsletter, SEO — automatically, in your voice.",
    },
    hero: {
      title: "Marketing that doesn't take your time",
      subtitle: "AI knows your coaching area, your tone and your target audience. It generates posts, articles, newsletters — you just approve.",
      cta: "Request Free Callback",
    },
    features: {
      title: "AI marketing tools for coaches",
      subtitle: "A detailed look at the most important marketing features",
      highlights: [
        {
          title: "Social media that writes itself",
          description: "AI generates your LinkedIn, Instagram and Facebook posts on coaching topics. It knows your specialty, your tone, and suggests relevant hashtags. One-click publish.",
          icon: "Share2",
          points: [
            "LinkedIn, Instagram, Facebook posts",
            "In your voice, on your topics",
            "Relevant hashtags automatically",
            "Content calendar and scheduled publishing",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Newsletter that brings clients",
          description: "Automatic email sequences for new leads, monthly newsletter for existing clients. AI writes the content, you just approve and send.",
          icon: "Mail",
          points: [
            "Automatic welcome email sequence",
            "Monthly newsletter generation",
            "Segmented sending by target group",
            "Open and click statistics",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Digital product sales",
          description: "Create and sell online coaching courses, e-books, workbooks. Automatic access after payment, integrated invoicing — passive income from your coaching expertise.",
          icon: "BookOpen",
          points: [
            "Online courses with video and assignments",
            "E-book and workbook sales",
            "Automatic access after payment",
            "Coupon codes and seasonal promotions",
          ],
          mockupLines: ["", "", "", "", ""],
        },
      ],
      items: [
        { title: "Social media posts", description: "LinkedIn, Instagram, Facebook post generation on coaching topics.", icon: "Share2" },
        { title: "Blog articles", description: "SEO-optimized professional articles that position you.", icon: "BookOpen" },
        { title: "Email marketing", description: "Newsletter series, automatic follow-up emails.", icon: "Mail" },
        { title: "SEO optimization", description: "Automatic keyword analysis and suggestions.", icon: "Search" },
        { title: "Content calendar", description: "Weekly/monthly content calendar, scheduled publishing.", icon: "Calendar" },
        { title: "Online courses", description: "Create and sell online coaching courses.", icon: "Video" },
        { title: "E-books", description: "Publish coaching e-books, workbooks.", icon: "BookOpen" },
        { title: "Coupons and promotions", description: "Create promo codes, seasonal promotions.", icon: "Tag" },
        { title: "Analytics", description: "Detailed statistics: which content brings the most clients.", icon: "BarChart" },
      ],
    },
    deepDive: {
      title: "How AI marketing works in practice",
      sections: [
        {
          title: "Content generation in seconds",
          description: "Tell the AI what you want to post about, and in minutes the full content is ready — in your voice, with relevant hashtags, in optimized format. For LinkedIn, Instagram, and Facebook simultaneously.",
          visual: "content",
        },
        {
          title: "Automatic scheduling and publishing",
          description: "With the content calendar, you schedule posts weeks in advance. The AI suggests optimal times and best platforms. One-click publish everywhere.",
          visual: "schedule",
        },
        {
          title: "Email marketing that converts",
          description: "Send automatic welcome sequences to new leads. The AI generates monthly newsletters for existing clients from your latest articles, success stories, and offers.",
          visual: "email",
        },
      ],
    },
    useCases: {
      title: "Marketing scenarios for coaches",
      items: [
        {
          title: "Weekly content production",
          description: "3 social media posts, 1 blog article, 1 newsletter — all AI-generated, in your voice, for the entire week in 30 minutes.",
        },
        {
          title: "Online course launch",
          description: "Complete launch campaign: teaser posts, landing page, email sequence, coupon codes — the AI plans and creates it all.",
        },
        {
          title: "Client acquisition funnel",
          description: "Lead magnet (free e-book) → email sequence → intro session booking → paid coaching program. Every step automated.",
        },
      ],
    },
    stats: [
      { value: "10 min", label: "Weekly content generation" },
      { value: "5x", label: "More online visibility" },
      { value: "347", label: "Average subscriber count" },
      { value: "40%", label: "Higher conversion" },
    ],
    faq: {
      title: "AI Marketing — FAQ",
      items: [
        { question: "Does the AI really write good posts?", answer: "Yes! The AI learns your coaching area and your tone. Generated content is professional, credible and personalized." },
        { question: "How does the content calendar work?", answer: "Set how many posts you want weekly/monthly and for which platforms. AI generates the content, you approve, and it's automatically published." },
        { question: "Can I sell online courses too?", answer: "Yes! You can create video, text and assignment-based courses. Clients get automatic access after payment." },
        { question: "How much does the marketing feature cost?", answer: "All marketing tools are included in the CoachWorld package. Basic plan: basic AI usage, Pro plan: AI assistant for daily work." },
        { question: "Can I set up automatic email sequences?", answer: "Yes! Welcome sequences for new leads, monthly newsletters, and follow-up emails — all sent automatically." },
        { question: "Which platforms are supported?", answer: "LinkedIn, Instagram, Facebook posts, email marketing, blog articles. The AI generates optimized content for each platform." },
      ],
    },
    cta: {
      title: "Start marketing with AI",
      subtitle: "Request a free callback and we'll show you how to generate your first week's content in 10 minutes.",
      button: "Request Free Callback",
    },
  },
  loading: "Loading...",
};
